import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/font-awesome-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M339.3 171.2c5.4 0 9.5 3 7.7 7.1v134.4c0 4.2-3 6-7.2 7.8-15.6 7.1-33.5 13.7-52 13.7-26.3 0-38.2-16.1-69.3-16.1-22.7 0-46 8.3-65.7 16.7-0.6 0.6-1.8 1.2-3 1.2v44.2c0 1.8 0 3-0.6 4.8v1.3c-2.4 7.7-9.5 13.7-18.5 13.7-10.7 0-19.7-8.9-19.7-19.7v-212.1c-7.7-6-12.5-15.5-12.5-25.7 0-18 14.3-32.3 32.3-32.3s32.3 14.4 32.3 32.3c0 10.8-4.7 19.7-12.5 25.7v17.9c1.2-0.6 3-1.2 4.8-1.8 17.9-7.1 39.4-13.7 59.7-13.7 22.1 0 39.4 5.9 59.1 13.7 4.1 1.8 8.3 2.4 12.5 2.4 22.7 0 46.6-15.5 52.6-15.5zM397.8 32c27.5 0 50.2 22.7 50.2 50.2v347.6c0 27.5-22.7 50.2-50.2 50.2h-347.6c-27.5 0-50.2-22.7-50.2-50.2v-347.6c0-27.5 22.7-50.2 50.2-50.2h347.6zM412.1 429.7v-347.6c0-7.7-6.5-14.3-14.3-14.3v0.1h-347.6c-7.7 0-14.3 6.5-14.3 14.3v347.5c0 7.7 6.5 14.3 14.3 14.3h347.6c7.7 0 14.3-6.5 14.3-14.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/font-awesome-alt.js
// module id = 831
// module chunks = 0